import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../../../store/hooks'
import { selectMeetingSummaryAgentShowChat, setMeetingSummaryShowChat } from '../../../../../../../store/meetingSummaryAgent/meetingSummaryAgent'
import { Button } from '../../../../../../../components/Button/Button'
import { ReactComponent as Sparkling } from '../../../../../../../assets/images/sparkling.svg'
import './MeetingSummaryAgentChatButton.scss'
import classNames from 'classnames'
import { TrackEvent, useTracking } from '../../../../common/tracking'

export const MeetingSummaryAgentChatButton: React.FC = () => {
  const dispatch = useAppDispatch()
  const { tracked } = useTracking()
  const showChat = useAppSelector(selectMeetingSummaryAgentShowChat)

  const _handleShowChat = () => {
    dispatch(setMeetingSummaryShowChat(!showChat))
  }

  const handleShowChat = tracked(_handleShowChat, {
    eventName: TrackEvent.MEETING_SUMMARY_AGENT_CHAT_CLICKED,
    eventDetails: { action: !showChat ? 'closed' : 'opened' },
  })

  return (
    <Button variant='header' className={classNames('px-2 py-1 button-medium', { 'bg-black zocks-border-color-black': showChat })} onClick={handleShowChat}>
      <div className='d-flex gap-2 align-items-center py-1 zocks-px-0.75 zocks-border-0.25 bg-black text-white'>
        <Sparkling className='zocks-text-white' />
        Ask Assistant
      </div>
      <i className={classNames('bi bi-pin-angle', { 'text-white': showChat })} />
    </Button>
  )
}
